export const uploadToCloudinary = async (file) => {
  const CLOUD_NAME = import.meta.env.VITE_CLOUDINARY_CLOUD_NAME;
  // const UPLOAD_PRESET = import.meta.env.VITE_CLOUDINARY_PRESET_KEY;
  const CLOUDINARY_URL = import.meta.env.VITE_CLOUDINARY_URL;

  const UPLOAD_PRESET = "sgw5zgye";
  const formData = new FormData();
  formData.append("file", file);
  formData.append("upload_preset", UPLOAD_PRESET);
  formData.append("resource_type", "raw");
  formData.append("folder", "sfs-quotes");

  const response = await fetch(
    `https://api.cloudinary.com/v1_1/dbebbayiq/image/upload`,
    {
      method: "POST",
      body: formData,
    }
  );
  if (!response.ok) {
    throw new Error("Cloudinary upload failed");
  }

  const data = await response.json();
  return data.secure_url;
};
